import Dashboard from '../pages/Dashboard'
import Users from '../pages/Users'
import PageNotFound from '../pages/errors/PageNotFound'
import AppLayout from '../layouts/AppLayout'

export const MainRoutes =  [
    {
        path: '/',
        element: <AppLayout />,
        children: [
            {
                index: true,
                element: <Dashboard />
            },
            {
                path: 'users',
                element: <Users />
            }
        ]
    },
    {
        path: '*',
        element: <PageNotFound />
    }
]